import { BOARD_RULES_HREF } from "@/shared/lib/mixReturn";
import { TextLink } from "@/shared/ui/navigation/TextLink";

/** 投稿欄下に置く注意書き */
export const PostNotice: React.FunctionComponent = () => {
  return (
    <p className="text-xs text-center text-muted-foreground">
      投稿により
      <TextLink href={BOARD_RULES_HREF}>利用規約</TextLink>
      に同意したものとみなします.
    </p>
  );
};
